<template>
<span class="scale-block">
  <!-- <el-button class="scaleDetail" type="primary" size="mini">详情</el-button> -->
  <CapacityBlock class="energyStorageBlock" :listData="energyStorageData"></CapacityBlock>
  <CapacityBlock class="photovoltaicBlock" :listData="photovoltaicData"></CapacityBlock>
  <CapacityBlock class="chargingPileBlock" :listData="chargingPileData"></CapacityBlock>
</span>
</template>

<script>
import CapacityBlock from "./capacity-block";
export default {
  props: {
    capacityData: {
      type: Object
    }
  },
  components: {
    CapacityBlock
  },
  data() {
    return {
      scaleBlockData: {},
      energyStorageData: {
        number: '',
        power: '',
        unit: '',
        powerUnit: '',
        title: "储能总容量",
        type: "energyStorage"
      },
      photovoltaicData: {
        number: '',
        unit: '',
        title: "光伏总容量",
        type: "photovoltaic"
      },
      chargingPileData: {
        number: '',
        unit: '',
        title: "充电桩总容量",
        type: "chargingPile"
      }
    }
  },
  watch: {
    capacityData(val) {
      this.scaleBlockData = val;
      this.energyStorageData = {
        number: val.energyStorageCapacity,
        power: val.energyStoragePower,
        unit: val.storageUnit,
        powerUnit: val.powerUnit,
        title: "储能总容量",
        type: "energyStorage"
      }
      this.photovoltaicData = {
        number: val.solarCapacity,
        unit: val.solarUnit,
        title: "光伏总容量",
        type: "photovoltaic"
      }
      this.chargingPileData = {
        number: val.chargingPileCapacity,
        unit: val.chargingPileUnit,
        title: "充电桩总容量",
        type: "chargingPile"
      }
    }
  },
  methods: {},
  mounted() {
    this.energyStorageData = {
      number: this.capacityData.energyStorageCapacity,
      power: this.capacityData.energyStoragePower,
      unit: this.capacityData.storageUnit,
      powerUnit: this.capacityData.powerUnit,
      title: "储能总容量",
      type: "energyStorage"
    }
    this.photovoltaicData = {
      number: this.capacityData.solarCapacity,
      unit: this.capacityData.solarUnit,
      title: "光伏总容量",
      type: "photovoltaic"
    }
    this.chargingPileData = {
      number: this.capacityData.chargingPileCapacity,
      unit: this.capacityData.chargingPileUnit,
      title: "充电桩总容量",
      type: "chargingPile"
    }
  }
}
</script>

<style lang="scss">
.scale-block {
  position: relative;
  top: 0;
  left: 0;
  width: 360px;
  height: 25vh;
  display: inline-block;
  margin-bottom: 7.5vh;

  // .scaleDetail {
  //     float: right;
  // }

  .energyStorageBlock {
    background: url("/static/images/svolt/energyStorage.png") no-repeat;
    background-size: 100% 100%;
    width: 360px;
    height: 105px;
    position: absolute;
    top: 3%;
  }

  .photovoltaicBlock {
    background: url("/static/images/svolt/photovoltaic.png") no-repeat;
    background-size: 100% 100%;
    width: 360px;
    height: 105px;
    position: absolute;
    top: 45%;
  }

  .chargingPileBlock {
    background: url("/static/images/svolt/chargingPile.png") no-repeat;
    background-size: 100% 100%;
    width: 360px;
    height: 105px;
    position: absolute;
    top: 87%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/svolt/components/scale-block.vue